/**
 * Splits the string a badge or list cell stores into entries. The comma is the
 * only separator, since the grid's editor sends Enter to the next cell; line
 * breaks count as one, and markdown bullets and numbering are shed.
 */
export function parseListItems(value: string): string[] {
  return value
    .split(/[\r\n,]+/)
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => item.replace(/^(?:[-*•]|\d+[.)])\s+/, ""));
}

export function dedupeItems(items: string[]): string[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    const key = item.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
